import { render, staticRenderFns } from "./TheSettingsModal.vue?vue&type=template&id=90803df0&"
import script from "./TheSettingsModal.vue?vue&type=script&lang=js&"
export * from "./TheSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports